const inputType = {
	text: 'text',
	textarea: 'textarea',
	email: 'email',
	url: 'url',
	numeric: 'numeric',
};
export default inputType;
